export default "__VITE_ASSET__77eced42__"